import React, { memo, type SyntheticEvent } from 'react';
import { LinkButton } from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/utility/add';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	onClick?: (event: SyntheticEvent) => void;
};

const AddIconWrapper = () => (
	<Box xcss={addIconWrapperStyles}>
		<AddIcon label="add" color={token('color.icon')} />
	</Box>
);

const AddIssueTypesButton = ({ onClick }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={buttonStyles}>
			<LinkButton
				href="#"
				onClick={onClick}
				iconBefore={AddIconWrapper}
				appearance="subtle"
				testId="business-summary.ui.summary-view.types-of-work.add-issue-types-button"
			>
				{formatMessage(messages.addIssueTypes)}
			</LinkButton>
		</Box>
	);
};

export default memo<Props>(AddIssueTypesButton);

const ICON_SIZE = 24;

const addIconWrapperStyles = xcss({
	height: `${ICON_SIZE}px`,
	width: `${ICON_SIZE}px`,
	borderRadius: 'border.radius',
	marginRight: 'space.075',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: 'color.background.neutral',
	paddingTop: 'space.100',
	paddingBottom: 'space.100',
	paddingLeft: 'space.050',
	paddingRight: 'space.075',
	boxSizing: 'border-box',
});

const buttonStyles = xcss({
	alignSelf: 'flex-start',
	marginLeft: 'space.negative.100',
	marginTop: 'space.100',
});
